import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "card-body py-3" }

import { textSearch } from "@/assets/ts/_utils";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { SortProps, sortFn } from "@/core/helpers/sort";
import Page from "@/layout/Page.vue";
import { FormulariosModule } from "@/store/modules";
import Swal from "sweetalert2";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { useArrayPagination } from "vue-composable";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const store = useStore();
const module = getModule(FormulariosModule, store);

const solicitudes = computed(() => {
  return module.solicitudesListado?.map((ele) => {
    return {
      ...ele,
      requerido: ele.entidadesSolicitudInformacionExterna.length || 0,
      respuestas:
        ele.entidadesSolicitudInformacionExterna.filter(
          (ele) => ele.respondido === false
        ).length || 0,
    };
  });
});

const formatDate = (row, column) => {
  return new Date(row[column.property]).toLocaleDateString();
};

// Exportar a Excel.
const csvLabels = {
  denominacion: t("csv.listados.proyectosN2.denominacion"),
  organismoNombre: t("csv.listados.proyectosN2.organismo"),
  importe: t("csv.listados.proyectosN2.importe"),
  codigo: t("csv.listados.proyectosN2.codigo"),
};
const csvFields = Object.keys(csvLabels);
const csvName = "Proyectos" + new Date().getTime() + ".xlsx";

// Busqueda y ordenación.
const search = ref("");
const sortProps = ref<SortProps>({
  prop: "createdOn",
  order: "descending",
  method: null,
});
const sortChange = ({ column, prop, order }) => {
  sortProps.value = { prop, order, method: column.sortMethod };
};
const filteredCollection = computed(function () {
  return solicitudes.value
    .slice()
    .sort(sortFn(sortProps))
    .filter((data) => {
      return (
        !search.value ||
        textSearch(data.denominacion, search.value) ||
        textSearch(data.descripcion, search.value)
        // TODO: añadir más campos a buscar
      );
    });
});

// Paginación.
const { result, currentPage } = useArrayPagination(filteredCollection, {
  pageSize: 100,
});
const handleCurrentPageChange = (page: number) => (currentPage.value = page);

const cargaListado = ref(false);
const load = async () => {
  cargaListado.value = true;
  try {
    await module.fetchAllSolicitudes();
    search.value = "";
    currentPage.value = 1;
  } catch (error) {
    Swal.fire({
      text: t("formularios.solicitudesListado.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    cargaListado.value = false;
  }
};

const crearNuevo = () => {
  router.push("recoleccion-de-datos/nuevo");
};
const handleEdit = (index, row) => {
  router.push(`recoleccion-de-datos/${row.id}`);
};

onBeforeMount(() => {
  load();
});
onMounted(() =>
  setCurrentPageBreadcrumbs(t("menu.recogidaDatos"), [
    t("menu.planCorresponsables"),
  ])
);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Page, null, {
    actions: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: crearNuevo
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("tabla.serviciosProgramadosListado.crear.boton")), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("tabla.recogidaDatosListado.titulo")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(result),
            style: {"width":"100%"},
            stripe: "",
            "default-sort": { prop: 'createdOn', order: 'descending' },
            onSortChange: sortChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.recogidaDatosListado.cabecera.fecha'),
                prop: "createdOn",
                formatter: formatDate,
                sortable: "",
                "min-width": "150"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.recogidaDatosListado.cabecera.denominacion'),
                prop: "denominacion",
                sortable: "",
                "min-width": "100"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: 
              _ctx.$t('tabla.recogidaDatosListado.cabecera.organismosRequeridos')
            ,
                prop: "requerido",
                sortable: "",
                "min-width": "100"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.requerido), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _ctx.$t('tabla.recogidaDatosListado.cabecera.sinRespuesta'),
                prop: "respuestas",
                sortable: "",
                "min-width": "100"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.respuestas), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                width: "50",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "text",
                    onClick: ($event: any) => (handleEdit(scope.$index, scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("tabla.profesionalesListado.fila.ver")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, cargaListado.value]
          ]),
          _createVNode(_component_el_pagination, {
            class: "my-5 float-end",
            background: "",
            "page-size": 100,
            layout: "prev, pager, next",
            total: _unref(solicitudes).length,
            "hide-on-single-page": true,
            "current-page": _unref(currentPage),
            onCurrentChange: handleCurrentPageChange
          }, null, 8, ["total", "current-page"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})